import React from "react";
import styled from "styled-components";
import { FiGithub } from "react-icons/fi";
import { HiOutlineMail } from "react-icons/hi";

interface ADProps {
  author: {
    role: string;
    nickname: string;
    avatar: string;
    github: string;
    contact: string;
    desc: string;
  };
}

const AuthorWrapper = styled.div`
  width: 100%;
  height: 135px;
  display: grid;
  grid-template-columns: 85px 1fr;
  grid-column-gap: 25px;
  align-items: center;
  justify-content: center;
  & > div.author-desc {
    display: grid;
    grid-template-rows: auto;
    & > p {
      margin: 0;
      font-size: 1em;
      align-items: center;
      display: grid;
      grid-template-columns: auto auto 1fr;
      grid-template-rows: auto;
      grid-column-gap: 10px;
    }
  }
`;

const AvatarThumbnail = styled.img`
  width: 85px;
  height: 85px;
  border-radius: 50%;
  border: 2px dotted lightgray;
`;

const AuthorDetail = (props: ADProps) => {
  const { role, nickname, avatar, github, contact, desc } = props.author;

  return (
    <AuthorWrapper>
      <AvatarThumbnail src={avatar} alt={nickname || ``} />
      <div className="author-desc">
        <p>
          {nickname} <small>{role}</small>
        </p>
        <p>{desc}</p>

        <p>
          <a href={github}>
            <FiGithub />
          </a>
          <HiOutlineMail />
          <small>{contact}</small>
        </p>
      </div>
    </AuthorWrapper>
  );
};

export default AuthorDetail;
